export const formatNumberIndian = (number: number | string) => {
  const num = Number(number);
  return num.toLocaleString("en-IN");
};

export const formatShortPrice = (amount: number): string => {
  if (amount >= 1_00_00_000) {
    const crore = amount / 1_00_00_000;
    return crore % 1 === 0 ? `${crore.toFixed(0)} Cr` : `${crore.toFixed(1)} Cr`;
  } else if (amount >= 1_00_000) {
    const lakh = amount / 1_00_000;
    return lakh % 1 === 0 ? `${lakh.toFixed(0)} Lac` : `${lakh.toFixed(1)} Lac`;
  } else if (amount >= 1_000) {
    const thousand = amount / 1_000;
    return thousand % 1 === 0 ? `${thousand.toFixed(0)}K` : `${thousand.toFixed(1)}K`;
  } else {
    return amount.toString();
  }
};


